const BATCH_STATUSES = {
  COMPLETE: 'LAST_SUCCESSFUL_SYNC',
  FAILED: 'LAST_FAILED_SYNC',
  CANCELLED: 'LAST_CANCELLED_SYNC',
  'IN PROCESS': 'BATCH_IN_PROGRESS',
  'IN_PROGRESS': 'BATCH_IN_PROGRESS',
  NEW: 'BATCH_IN_PROGRESS',
  NOT_AVAILABLE: 'LAST_BATCH_STATUS_NOT_AVAILABLE',
  STATUS_INDICATOR_FAIL: 'STATUS_INDICATOR_FAIL',
  INVALID: 'INVALID_ZIP'
};

export default BATCH_STATUSES;



// WEBPACK FOOTER //
// ./app/models/batchStatuses.js